// ReadinessGauge — Horizontal bar gauge for readiness/energy display
import React from 'react';

const COLOR_MAP = {
  green: { bar: 'bg-green-500', bg: 'bg-green-100', text: 'text-green-700' },
  blue:  { bar: 'bg-blue-500',  bg: 'bg-blue-100',  text: 'text-blue-700' },
  yellow: { bar: 'bg-yellow-500', bg: 'bg-yellow-100', text: 'text-yellow-700' },
  red:   { bar: 'bg-red-500',   bg: 'bg-red-100',   text: 'text-red-700' },
};

export default function ReadinessGauge({ score, level, label = 'Score', className = '' }) {
  const colors = COLOR_MAP[level?.color] || COLOR_MAP.blue;

  return (
    <div className={className}>
      <div className="flex items-center justify-between mb-1">
        <span className="text-[11px] font-medium text-gray-600">{label}</span>
        <span className={`text-[11px] font-bold ${colors.text}`}>
          {score}/100 — {level?.label || ''}
        </span>
      </div>
      <div className={`h-2 rounded-full ${colors.bg} overflow-hidden`}>
        <div
          className={`h-full rounded-full ${colors.bar} transition-all duration-500`}
          style={{ width: `${Math.max(2, Math.min(100, score))}%` }}
        />
      </div>
    </div>
  );
}
